/**
 *
 * ResultsItem
 *
 */

import React, { memo, FunctionComponent } from 'react';
import helmetIcon from '../../../../assets/icons/helmet.svg';
import horseIcon from '../../../../assets/icons/horse.svg';
import { EventType, LiveFeedEventResult } from '../../../../domain';

interface IProps {
  result: LiveFeedEventResult;
  type?: EventType;
  sjPhasesCount: number;
  disabledFields: string[];
  desktopVisible: boolean;
  mobileVisible: boolean;
  tabletVisible: boolean;
  isScoringEntered?: boolean;
}

const ResultsItem: FunctionComponent<IProps> = ({
  result,
  type,
  sjPhasesCount,
  disabledFields,
  desktopVisible,
  mobileVisible,
  tabletVisible,
}) => {
  const isEnabled = (field: string) => {
    return !disabledFields.includes(field);
  };
  const phases = [...Array(sjPhasesCount)];

  return (
    <tr>
      <td>{isEnabled('eaEventClassAndSort') && result.eaEventClassAndSort}</td>
      <td>{isEnabled('sectionName') && result.sectionName}</td>
      <td>
        {isEnabled('bridleNumber') && (
          <div className="fw-7">{result.bridleNumber}</div>
        )}
      </td>
      <td>
        <div className="d-flex align-items-center text-nowrap">
          <img src={helmetIcon} className="mr-11 tablet-hidden" alt="" />
          <div className="fs-12 fw-7">
            {result.riderFirstName} {result.riderLastName}
          </div>
        </div>
        <div className="tablet-visible">
          {result.customHorseName || result.horseName}
        </div>
      </td>
      <td className="horse-detailed">
        <div className="d-flex align-items-center tablet-hidden">
          <img src={horseIcon} className="mr-11 tablet-hidden" alt="" />
          <div className="d-flex flex-column">
            <div className="fs-12 fw-7 text-nowrap">
              {result.customHorseName || result.horseName}
            </div>
            <div className="fs-12 txt-secondary">
              Owner: {result.ownerFirstName} {result.ownerLastName}{' '}
            </div>
          </div>
        </div>
      </td>
      {desktopVisible &&
        phases.map((_, index) => (
          <React.Fragment key={index}>
            <td>
              {isEnabled(`phase${index + 1}JF`) && (
                <div>{result[`phase${index + 1}JF`]}</div>
              )}
            </td>
            <td>
              {isEnabled(`phase${index + 1}TF`) && (
                <div>{result[`phase${index + 1}TF`]}</div>
              )}
            </td>
            <td>
              {isEnabled(`phase${index + 1}F`) && (
                <div>{result[`phase${index + 1}F`]}</div>
              )}
            </td>
            <td>
              {isEnabled(`phase${index + 1}RecTime`) && (
                <div>{result[`phase${index + 1}RecTime`]}</div>
              )}
            </td>
          </React.Fragment>
        ))}
      {tabletVisible &&
        phases.map((_, index) => (
          <React.Fragment key={index}>
            <td>
              {result.isScoringEntered && (
                <>
                  {result[`phase${index + 1}JF`] + '-'}
                  {result[`phase${index + 1}TF`] + '-'}
                  {result[`phase${index + 1}F`] + '-'}
                  {result[`phase${index + 1}RecTime`]}
                </>
              )}
            </td>
          </React.Fragment>
        ))}

      {mobileVisible && (
        <td style={{ whiteSpace: 'nowrap' }}>
          {result.isScoringEntered && (
            <>
              {phases.map((_, index) => (
                <React.Fragment key={index}>
                  {result[`phase${index + 1}F`]}
                  {index === phases.length - 1 ? '' : '-'}
                </React.Fragment>
              ))}{' '}
              {Boolean(phases.length) &&
                `/${result[`phase${phases.length}RecTime`]}`}
            </>
          )}
        </td>
      )}
      <td className="mobile-hidden">
        {isEnabled('totalJFaults') &&
          result.isScoringEntered &&
          result.totalJFaults}
      </td>
      <td>
        {isEnabled('sectionPlace') && (
          <div className="fw-7">{result.sectionPlace}</div>
        )}
      </td>
      <td>
        {isEnabled('sjPlace') && <div className="fw-7">{result.sjPlace}</div>}
      </td>
      <td width="100px">
        {isEnabled('riderClassStatusCode') && (
          <div className="fw-7 fs-12">{result.riderClassStatusCode}</div>
        )}
      </td>
    </tr>
  );
  // return (
  //   <StyledCard ref={ref} className="mt-10 mb-10">
  //     <div className="card-body">
  //       <div className="row">
  //         <div className="col-2">
  //           {isEnabled('bridleNumber') && (
  //             <>
  //               <div className="fw-7">{result.bridleNumber}</div>
  //               <div className="txt txt-secondary fs-11">Rider/BN</div>
  //             </>
  //           )}
  //         </div>
  //         <div className="col-7">
  //           {isEnabled('eaEventClassAndSort') && (
  //             <>
  //               <div className="txt">{result.eaEventClassAndSort}</div>
  //               <div className="txt txt-secondary fs-11">Class</div>
  //             </>
  //           )}
  //           {isEnabled('sectionName') && (
  //             <>
  //               <div className="txt mt-15">{result.sectionName}</div>
  //               <div className="txt txt-secondary fs-11">Section</div>
  //             </>
  //           )}
  //           <div className="d-flex mt-15">
  //             <img src={helmetIcon} className="mr-11" alt="" />
  //             <div className="fs-12 fw-7">
  //               {result.riderFirstName} {result.riderLastName}
  //             </div>
  //           </div>
  //           <div className="d-flex align-items-center">
  //             <img src={horseIcon} className="mr-11" alt="" />
  //             <div>
  //               <div className="fs-12 fw-7">
  //                 {isAffiliated && result.bsjaHorseName
  //                   ? result.bsjaHorseName
  //                   : result.horseName}
  //               </div>
  //               <div className="fs-12">
  //                 Owner: {result.ownerFirstName} {result.ownerLastName}
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //         <div className="col-3 txt-right">
  //           {isEnabled('riderClassStatusCode') && (
  //             <>
  //               <p className="txt fw-7 txt-accent name">
  //                 {result.riderClassStatusCode}
  //               </p>
  //               <p className="txt txt-secondary fs-11">Status</p>
  //             </>
  //           )}
  //           {isEnabled('sjPlace') && (
  //             <>
  //               <p className="txt fw-7 mt-15">{result.sjPlace}</p>
  //               <p className="txt txt-secondary fs-11">Place</p>
  //             </>
  //           )}
  //         </div>
  //       </div>
  //       <div className="row mt-20">
  //         <div className="col-2"></div>
  //         {[...Array(sjPhasesCount)].map((_, index) => (
  //           <div className="col-3">
  //             {isEnabled(`phase${index + 1}JF`) && (
  //               <>
  //                 <div className="txt">{result[`phase${index + 1}JF`]}</div>
  //                 <div className="txt txt-secondary fs-11">
  //                   Phase {index + 1} JF
  //                 </div>
  //               </>
  //             )}
  //             {isEnabled(`phase${index + 1}TF`) && (
  //               <>
  //                 <div className="txt mt-10">
  //                   {result[`phase${index + 1}TF`]}
  //                 </div>
  //                 <div className="txt txt-secondary fs-11">
  //                   Phase {index + 1} TF
  //                 </div>
  //               </>
  //             )}
  //             {isEnabled(`phase${index + 1}F`) && (
  //               <>
  //                 <div className="txt mt-10">
  //                   {result[`phase${index + 1}F`]}
  //                 </div>
  //                 <div className="txt txt-secondary fs-11">
  //                   Phase {index + 1} F
  //                 </div>
  //               </>
  //             )}
  //             {isEnabled(`phase${index + 1}RecTime`) && (
  //               <>
  //                 {' '}
  //                 <div className="txt mt-10">
  //                   {result[`phase${index + 1}RecTime`]}
  //                 </div>
  //                 <div className="txt txt-secondary fs-11">
  //                   Phase {index + 1} Rec Time
  //                 </div>
  //               </>
  //             )}
  //           </div>
  //         ))}
  //         <div className="col-1"></div>
  //       </div>
  //     </div>
  //   </StyledCard>
  // );
};

export default memo(ResultsItem);
